export default __webpack_public_path__ + "assets/images/granulation_7ba9a53518f0990277799f1648676ba3.jpg";